import { date } from '@ipfabric/utils';

export const timezoneOptions = date.timezones.map((name) => ({
  value: name,
  label: name,
}));
